export default __webpack_public_path__ + "static/media/babcock_int.bcd8e2a4.png";